/**
 * versionDisplay — human-readable version string for MCP responses (BET-112, FEAT-287, STD-60)
 *
 * Agents receive versionDisplay ('Draft' or 'vN') alongside raw version (number | null)
 * so they don't assume version is always a number. Drafts have no committed version.
 */

/**
 * Returns 'Draft' when version is null, undefined, or 0 (no commits yet).
 * Returns 'vN' for committed versions (1, 2, 3, ...).
 */
export function toVersionDisplay(version: number | null | undefined): string {
  if (version == null || version === 0) return "Draft";
  return `v${version}`;
}
